import axios from "@/axios";
import * as web3Service from "@/services/web3Service.ts";
import BigNumber from "bignumber.js";

export const routerV6Address = "0x111111125421cA6dc452d289314280a0f8842A65";

const cachedLiquiditySourcesByChain = {};
let cachedAccessToken;

export async function getLiquiditySources(chainId: number) {
  if (!cachedLiquiditySourcesByChain[chainId]) {
    cachedLiquiditySourcesByChain[chainId] = (await axios.get(`https://configs.1inch.io/frontend/liquidity-sources/${chainId}/liquidity-sources.json`)).data;
  }
  return cachedLiquiditySourcesByChain[chainId];
}

export async function getAccessToken() {
  if ((cachedAccessToken?.exp || 0) * 1000 - Date.now() < 900000) {
    cachedAccessToken = (await axios.get("https://proxy-app.1inch.io/v2.0/auth/token?ngsw-bypass")).data;
  }
  return cachedAccessToken;
}

export async function getQuote(chainId: number, params: any) {
  const [accessTokenInfo, liquiditySources] = await Promise.all([getAccessToken(), getLiquiditySources(chainId)]);
  params.excludedProtocols = liquiditySources.filter(s => s.isOtcMode).map(s => s.id).join(",");

  const ret = (await axios.get(`https://proxy-app.1inch.io/v2.0/v2.2/chain/${chainId}/router/v6/quotesv2`, {
    headers: {
      Authorization: `Bearer ${accessTokenInfo.access_token}`
    },
    params,
    signal: AbortSignal.timeout(10000),
  })).data;
  ret.accessTokenInfo = accessTokenInfo;
  ret.requestParams = params;
  return ret;
}


export async function buildSwapTx(quoteRes, chainId: number, data: any) {
  const fetchBalanceAndAllowance = web3Service.getBalancesAndAllowances(
    chainId, data.walletAddress, routerV6Address, [data.fromTokenAddress]
  );
  const fetchBuildSwapData = axios.post(`https://proxy-app.1inch.io/v2.0/v6.0/${chainId}/swap/build`, data, {
    headers: {
      Authorization: `Bearer ${quoteRes.accessTokenInfo.access_token}`
    },
    signal: AbortSignal.timeout(10000),
  });

  const { balance, allowance } = (await fetchBalanceAndAllowance)[data.fromTokenAddress.toLowerCase()];
  const amountInBN = BigNumber(data.amount);
  if (amountInBN.gt(balance.toString())) {
    throw Object.assign(Error("not enough balance"), { code: "notEnoughBalance", balance, allowance, amount: data.amount });
  } else if (allowance !== undefined && amountInBN.gt(allowance.toString())) {
    throw Object.assign(Error("not enough allowance"), { code: "notEnoughAllowance", balance, allowance, amount: data.amount });
  }

  const ret = (await fetchBuildSwapData).data;
  if (!ret.estimation) {
    throw Error("simulation failed: execution reverted");
  }

  ret.fromTokenAddress = data.fromTokenAddress;
  ret.toTokenAddress = data.toTokenAddress;
  ret.amount = data.amount;
  return ret;
}
